import { openGame } from "@pages/casino/utils";
import {
	CompletedBonusItemWrapper,
	CompletedInfoHeader,
} from "@pages/profile-v2/pages/bonuses/containers/Completed/BonusItem/elements.js";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ArrowDownIcon from "../../../../../assets/icons/ArrowDownIcon.jsx";
import PlayNowIcon from "../../../../../assets/icons/PlayNowIcon.jsx";
import {
	ButtonText,
	ContentButton,
	ContentTitle,
	Date,
	DateWrapper,
	DetailsButton,
	ItemContent,
	ItemContentWrapper,
	ItemImg,
	ItemTitle,
	ItemWrapper,
} from "./elements.js";

const FreeSpinItem = ({ data, goToLink, key, translate, showAlert, index, isCompletedPage }) => {
	const [openDetailsIndex, setOpenDetailsIndex] = useState(null);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const { provider, game, amount, validity } = data;

	const handleDetailsButtonClick = (index) => {
		setOpenDetailsIndex(openDetailsIndex === index ? null : index);
	};

	const handlePlayNowClick = (game) => {
		openGame(game, goToLink, showAlert);
	};

	const areDetailsOpen = openDetailsIndex === index;

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const shouldShowDetails = windowWidth >= 768 || areDetailsOpen;

	const startDate = moment.unix(validity.startTime).format("DD/MM/YYYY HH:mm");
	const endDate = moment.unix(validity.endTime).format("DD/MM/YYYY HH:mm");

	return (
		<CompletedBonusItemWrapper>
			{isCompletedPage && (
				<CompletedInfoHeader>{translate("BONUS_CONVERT_COMPLETED")}</CompletedInfoHeader>
			)}
			<ItemWrapper key={key}>
				<ItemTitle>
					{provider?.toUpperCase()} | {game?.name?.toUpperCase()}
				</ItemTitle>
				<ItemContentWrapper>
					<ItemImg src={game?.icon} />
					<ItemContent>
						<ContentTitle>
							<span>{amount}</span> <span>{translate("SPIN")}</span>
						</ContentTitle>
						<ContentButton
							isCompletedPage={isCompletedPage}
							onClick={() => handlePlayNowClick({ ...game, provider })}>
							<PlayNowIcon />
							{translate("PLAY_NOW")}
						</ContentButton>
					</ItemContent>
				</ItemContentWrapper>
				{shouldShowDetails ? (
					<DateWrapper>
						<Date>
							{translate("Start")}: {startDate}
						</Date>
						<Date>
							{translate("Last")}: {endDate}
						</Date>
					</DateWrapper>
				) : null}
				{windowWidth < 768 && (
					<DetailsButton
						rotate={areDetailsOpen}
						onClick={() => handleDetailsButtonClick(index)}>
						<ButtonText>
							{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
						</ButtonText>
						<ArrowDownIcon />
					</DetailsButton>
				)}
			</ItemWrapper>
		</CompletedBonusItemWrapper>
	);
};

export default FreeSpinItem;
